import Enum from 'redpoints-model-js-common/enumeration/Enum';

class FilterByEnum extends Enum {
  static CUSTOMER;
  static CONTRACT;
  static TENANT;
}

FilterByEnum.initEnum({
  CUSTOMER: 'customer',
  CONTRACT: 'contract',
  TENANT: 'tenant',
});

export default FilterByEnum;
